export const servicesData = [
  {
    icon: "las la-cookie",
    title: "کیک",
    description: "",
  },
  {
    icon: "las la-carrot",
    title: "صبحانه",
    description: "",
  },
  {
    icon: "las la-hamburger",
    title: "فست فود",
    description: "",
  },
  {
    icon: "las la-fish",
    title: "شیک",
    description: "",
  },
  {
    icon: "las la-pizza-slice",
    title: "سالاد و پیش غذا",
    description: "",
  },
  {
    icon: "las la-glass-cheers",
    title: "نوشیدنی سرد",
    description: "",
  },
  {
    icon: "las la-mug-hot",
    title: "قهوه",
    description: "",
  },
  {
    icon: "las la-seedling",
    title: "نوشیدنی گرم",
    description: "",
  },
];
